import { cn } from "@padi/lib/utils";
import { Notification } from "../_types";
import { formatDistanceToNow } from "date-fns";
import { Bell, Mail } from "lucide-react";
import { useMarkRead } from "../_hooks/use-notifications";

interface NotificationItemProps {
  notification: Notification;
  onClick?: () => void;
}

export function NotificationItem({
  notification,
  onClick,
}: NotificationItemProps) {
  const { mutate: markRead } = useMarkRead();

  const handleClick = () => {
    if (!notification.isRead) {
      markRead(notification.id);
    }
    if (notification.actionUrl) {
      window.location.href = `/home/${notification.actionUrl}`;
    }
    onClick?.();
  };
  const { channel } = notification;

  const Icon = channel === "email" ? Mail : Bell;

  return (
    channel === "in_app" && (
      <div
        onClick={handleClick}
        className={cn(
          "flex items-start gap-4 p-4 border-b hover:bg-muted/50 transition-colors cursor-pointer",
          !notification.isRead && "bg-muted/20",
        )}
      >
        <div
          className={cn("p-2 rounded-full bg-primary/10 text-primary shrink-0")}
        >
          <Icon className="size-4" />
        </div>
        <div className="flex-1 space-y-1">
          <div className="flex items-center justify-between gap-2">
            <p
              className={cn(
                "text-sm font-medium leading-none",
                !notification.isRead && "font-semibold",
              )}
            >
              {notification.title}
            </p>
            <span className="text-xs text-muted-foreground shrink-0">
              {formatDistanceToNow(new Date(notification.createdAt), {
                addSuffix: true,
              })}
            </span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {notification.body}
          </p>
          {!notification.isRead && (
            <span className="inline-flex h-2 w-2 rounded-full bg-primary" />
          )}
        </div>
      </div>
    )
  );
}
